import { IonText, IonImg } from '@ionic/react';
import twoOFourImage from 'assets/204.png';
import classes from './style.module.scss';

const TwoOFour = ({ message }) => {
  return (
    <div className={classes.mainContainer}>
      <IonImg src={twoOFourImage} alt='No Content' />
      <IonText className={classes.oops}>Oops!</IonText>
      <IonText className={classes.message}>{message}</IonText>
    </div>
  );
};

export default TwoOFour;
